import { ButtonType, DialogFooterButtonsWidget } from '@tableau/widgets';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Messages } from '~src/codegen/Localize';
import { CloseAndDismiss } from '~src/commonInfra/dialogs/ReactModalService';
import { DialogFieldParentStyle } from '~src/commonInfra/dialogs/style/DialogStyles';
import { ToasterService, ToastType } from '~src/commonInfra/services/ToasterService';
import { MapDispatchToProps } from '~src/commonInfra/utils/ConnectUtils';
import { ExtractEncryptionMode } from '~src/commonInfra/utils/sites/SitePropertyTypes';
import { getCredentialEncryptionKeyRequest } from '~src/settings/security-settings/sections/credential-encryption/actions/GetCredentialEncryptionKeyRequestAction';
import { ISiteAdminSettings, ISiteSettingsForSiteAdmin } from '~src/settings/types/ISiteSettingsForSiteAdmin';

import { getExtractEncryptionKeyRequest } from '../actions/GetExtractEncryptionKeyRequestAction';
import { ActivateSiteEncryptionKeyRequest, ActivateSiteEncryptionKeyResult } from '../serverApi/requests/ActivateSiteEncryptionKeyRequest';
import { activateSiteEncryptionKey } from '../services/ExtractEncryptionKeyService';
import { updateSiteSettings } from '../services/UpdateSiteSettingsService';
import { getSetEncryptionModeEnforcedRequest } from '../utils/ExtractEncrpytionUtils';


export interface KMSKeyActivateViewOwnProps {
    closeDialog: CloseAndDismiss;
    externalKeyId: string;
    siteSettings: ISiteSettingsForSiteAdmin;
}

export interface KMSKeyActivateViewDispatchProps {
    retrieveExtractEncryptionKey: () => void;
    retrieveCredentialEncryptionKey: () => void;
}

export type KMSKeyActivateViewProps = KMSKeyActivateViewOwnProps & KMSKeyActivateViewDispatchProps;


export interface KMSKeyActivateViewState {
    isActivatingKey: boolean;
}

export class KMSKeyActivateViewComponent extends React.PureComponent<KMSKeyActivateViewProps, KMSKeyActivateViewState> {

    constructor(props: KMSKeyActivateViewProps) {
        super(props);
        this.state = {
            isActivatingKey: false,
        };
    }


    public render(): JSX.Element {
        return <>
            <div style={DialogFieldParentStyle}>{Messages.extractEncryption_KMSKeyActivateDialog_Description()}</div>
            <div style={DialogFieldParentStyle}>{Messages.extractEncryption_KMSKeyActivateDialog_Warning()}</div>
            <ul style={{paddingLeft: '20px'}}>
                <li id="kms-key-activate-terms-1">{Messages.extractEncryption_KMSKeyActivateDialog_Warning_1()}</li>
                <li id="kms-key-activate-terms-2">{Messages.extractEncryption_KMSKeyActivateDialog_Warning_2()}</li>
            </ul>
            <div id="kms-key-activate-validation-message">
                {Messages.extractEncryption_KMSKeyActivateDialog_validation_message()}
            </div>
            <br></br>
            <div style={{ position: 'relative' }}>
                <DialogFooterButtonsWidget
                    buttons={[
                        {
                            buttonType: ButtonType.Outline,
                            children: Messages.cancel(),
                            onClick: this.props.closeDialog.close,
                            testId: 'cancel-button'
                        },
                        {
                            buttonType: ButtonType.Primary,
                            showSpinner: this.state.isActivatingKey,
                            children: Messages.extractEncryption_KMSKeyActivateDialog_Activate_button(),
                            onClick: () => this.activateKey(),
                            testId: 'activate-button'
                        }
                    ]}
                />
            </div>
        </>;
    }

    private activateKey() {
        this.setState({isActivatingKey: true}, () => {
            activateSiteEncryptionKey(new ActivateSiteEncryptionKeyRequest({externalKeyId: this.props.externalKeyId}))
            .then((response: ActivateSiteEncryptionKeyResult) => {
                if(response.errors){
                    ToasterService.instance.pop({ type: ToastType.Error, text: Messages.extractEncryption_KMSKeyActivateDialog_FailureToast() });
                } else {
                    ToasterService.instance.pop({ type: ToastType.Success, text: Messages.extractEncryption_KMSKeyActivateDialog_SuccessToast() });
                    this.updateSiteSettings();
                    this.props.retrieveExtractEncryptionKey();
                    this.props.retrieveCredentialEncryptionKey();
                }
            })
            .catch(() => {
                ToasterService.instance.pop({ type: ToastType.Error, text: Messages.extractEncryption_KMSKeyActivateDialog_FailureToast() });
            }).finally(() => {
                this.setState({isActivatingKey: false});
                this.props.closeDialog.close();
            });
        });
    }

    private updateSiteSettings() {
        if((this.props.siteSettings?.siteAdminSettings as ISiteAdminSettings)?.extractEncryptionMode !== ExtractEncryptionMode.ENFORCED) {
            updateSiteSettings(getSetEncryptionModeEnforcedRequest(this.props.siteSettings));
        }
    }
}

const mapDispatchToProps: MapDispatchToProps<KMSKeyActivateViewDispatchProps> =
  (dispatch) => bindActionCreators({
    retrieveExtractEncryptionKey: getExtractEncryptionKeyRequest,
    retrieveCredentialEncryptionKey: getCredentialEncryptionKeyRequest
  },
  dispatch);

export const KMSKeyActivateView: React.ComponentClass<KMSKeyActivateViewOwnProps> =
  connect(undefined, mapDispatchToProps)(KMSKeyActivateViewComponent);